import React, { useState } from 'react';
import { formatDate, getAvatarColor } from '../compartidos/utils';
import documentosMaterialesService from '../../servicios/documentosMaterialesService';
import { enviarSolicitudProceso } from '../../servicios/notificacionesService';

function ModalProcesoMaterial({
  showMaterialModal, selectedMaterial, selectedMaterialStage,
  closeMaterialStageModal, handleMaterialFileUpload,
  materialStageFiles, setMaterialStageFiles,
  materialProcessNoAplica, setMaterialProcessNoAplica,
  materialStageComments, setMaterialStageComments,
  currentMaterialComment, setCurrentMaterialComment,
  saveMaterialStageData, completedProcessesMateriales,
  revertMaterialProcess, isRevertingMaterialProcess,
  markMaterialProcessComplete, isSavingMaterialProcess,
  teamMembers, projectName, usuarioActual
}) {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [emailDestinatarios, setEmailDestinatarios] = useState(new Set());
  const [emailLibre, setEmailLibre] = useState('');
  const [emailMensaje, setEmailMensaje] = useState('');
  const [enviandoCorreo, setEnviandoCorreo] = useState(false);
  const [emailEnviado, setEmailEnviado] = useState(false);

  if (!showMaterialModal || !selectedMaterial || !selectedMaterialStage) return null;

  const etapaLabel = selectedMaterialStage === 'cubicacion' ? 'Cubicación' :
    selectedMaterialStage === 'revCubicacion' ? 'Revisión Cubicación' :
    selectedMaterialStage === 'solped' ? 'Solped' :
    selectedMaterialStage === 'ocAprobada' ? 'OC Aprobada' : selectedMaterialStage;

  const toggleDestinatario = (memberId) => {
    setEmailDestinatarios(prev => {
      const next = new Set(prev);
      if (next.has(memberId)) next.delete(memberId);
      else next.add(memberId);
      return next;
    });
  };

  const handleEnviarSolicitud = async () => {
    const destinatarios = (teamMembers || []).filter(m => emailDestinatarios.has(m.id || m._id)).map(m => ({ nombre: m.name || m.nombre, email: m.email }));
    if (destinatarios.length === 0 && !emailLibre.trim()) {
      alert('Selecciona al menos un destinatario o ingresa un email');
      return;
    }
    if (!emailMensaje.trim()) {
      alert('Escribe un mensaje para la solicitud');
      return;
    }
    setEnviandoCorreo(true);
    try {
      await enviarSolicitudProceso({
        destinatarios,
        emailLibre: emailLibre.trim() || undefined,
        contexto: {
          tipo: 'material',
          nombreItem: selectedMaterial.text,
          especialidad: selectedMaterial.specialty || '',
          etapa: etapaLabel,
          projectName: projectName || 'Proyecto',
          remitente: usuarioActual?.nombre || usuarioActual?.email || 'Un miembro del equipo'
        },
        mensaje: emailMensaje.trim()
      });
      setEmailEnviado(true);
      setEmailMensaje('');
      setEmailDestinatarios(new Set());
      setEmailLibre('');
      setTimeout(() => setEmailEnviado(false), 4000);
    } catch (err) {
      alert('Error al enviar: ' + (err.response?.data?.error || err.message));
    } finally {
      setEnviandoCorreo(false);
    }
  };

  const fileKey = `${selectedMaterial.id}-${selectedMaterialStage}`;

  return (
    <div className="modal-overlay" onClick={closeMaterialStageModal} style={{ background: 'transparent', justifyContent: 'flex-end', pointerEvents: 'none' }}>
      <div className="modal-content proceso-modal" onClick={(e) => e.stopPropagation()} style={{ width: '480px', height: '100vh', borderRadius: '0', margin: '0', position: 'fixed', right: '0', top: '0', pointerEvents: 'all' }}>
        <div className="modal-header etapa-modal-header">
          <h3>Etapa: {selectedMaterialStage.toUpperCase()}</h3>
          <button className="modal-close" onClick={closeMaterialStageModal}>✕</button>
        </div>

        <div className="modal-body">
          <div className="modal-section">
            <h4>Información del Material</h4>
            <p><strong>Material:</strong> {selectedMaterial.text}</p>
            <p><strong>Proceso:</strong> {etapaLabel}</p>
            <p><strong>Fecha programada:</strong> {formatDate(selectedMaterial[selectedMaterialStage])}</p>
          </div>

          <div className="modal-section">
            <h4>Cargar Archivos</h4>
            <input
              type="file"
              accept=".pdf,.xlsx,.xls,.csv"
              multiple
              onChange={handleMaterialFileUpload}
              className="file-input"
            />
            <p className="file-info">Puedes cargar múltiples archivos (PDF, Excel, CSV)</p>

            {materialStageFiles[fileKey] && materialStageFiles[fileKey].length > 0 && (
              <div className="files-list">
                <h5>Archivos cargados:</h5>
                <ul>
                  {materialStageFiles[fileKey].map((file, index) => (
                    <li key={index} className="file-item">
                      <span>{file.name}</span>
                      <div className="file-actions">
                        <button
                          className="file-open-btn"
                          onClick={async () => {
                            if (file.fromMongoDB && file._id) {
                              try {
                                const response = await documentosMaterialesService.obtenerDocumento(file._id);
                                const doc = response.documento;
                                const byteCharacters = atob(doc.archivoBase64);
                                const byteNumbers = new Array(byteCharacters.length);
                                for (let i = 0; i < byteCharacters.length; i++) {
                                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], { type: doc.mimeType });
                                const url = URL.createObjectURL(blob);
                                window.open(url, '_blank');
                                setTimeout(() => URL.revokeObjectURL(url), 60000);
                              } catch (error) {
                                console.error('Error al abrir archivo:', error);
                                alert('Error al abrir el archivo');
                              }
                            } else {
                              const url = URL.createObjectURL(file);
                              window.open(url, '_blank');
                            }
                          }}
                          title="Abrir archivo"
                        >
                          Ver
                        </button>
                        <button
                          className="file-download-btn"
                          onClick={async () => {
                            if (file.fromMongoDB && file._id) {
                              try {
                                const response = await documentosMaterialesService.obtenerDocumento(file._id);
                                const doc = response.documento;
                                const byteCharacters = atob(doc.archivoBase64);
                                const byteNumbers = new Array(byteCharacters.length);
                                for (let i = 0; i < byteCharacters.length; i++) {
                                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], { type: doc.mimeType });
                                const url = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = doc.nombre;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(url);
                              } catch (error) {
                                console.error('Error al descargar archivo:', error);
                                alert('Error al descargar el archivo');
                              }
                            } else {
                              const url = URL.createObjectURL(file);
                              const a = document.createElement('a');
                              a.href = url;
                              a.download = file.name;
                              a.click();
                            }
                          }}
                          title="Descargar archivo"
                        >
                          Descargar
                        </button>
                        <button
                          className="file-remove-btn"
                          onClick={async () => {
                            if (file.fromMongoDB && file._id) {
                              try {
                                await documentosMaterialesService.eliminarDocumento(file._id);
                              } catch (error) {
                                console.error('Error al eliminar documento:', error);
                                alert('Error al eliminar el documento de la base de datos');
                                return;
                              }
                            }

                            setMaterialStageFiles(prev => ({
                              ...prev,
                              [fileKey]: prev[fileKey].filter((_, i) => i !== index)
                            }));
                          }}
                          title="Eliminar"
                        >
                          ✕
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginTop: '10px' }}>
              <input
                type="checkbox"
                checked={materialProcessNoAplica}
                onChange={(e) => setMaterialProcessNoAplica(e.target.checked)}
                style={{ marginRight: '8px', cursor: 'pointer' }}
              />
              <span style={{ fontWeight: '600' }}>
                Este proceso no aplica (completar sin archivos)
              </span>
            </label>
          </div>

          <div className="modal-section">
            <h4>Comentarios</h4>

            {materialStageComments[fileKey] && materialStageComments[fileKey].length > 0 && (
              <div className="comments-list">
                {materialStageComments[fileKey].map((comment) => (
                  <div key={comment.id} className="message-bubble">
                    <div className="message-header">
                      <span className="message-time">{comment.timestamp}</span>
                      <button
                        className="message-delete-btn"
                        onClick={() => {
                          setMaterialStageComments(prev => ({
                            ...prev,
                            [fileKey]: prev[fileKey].filter(c => c.id !== comment.id)
                          }));
                        }}
                        title="Eliminar comentario"
                      >
                        ✕
                      </button>
                    </div>
                    <p className="message-text">{comment.text}</p>
                  </div>
                ))}
              </div>
            )}

            <div className="comment-input-section">
              <textarea
                className="comment-textarea"
                placeholder="Agrega un comentario sobre esta etapa..."
                value={currentMaterialComment}
                onChange={(e) => setCurrentMaterialComment(e.target.value)}
                rows="3"
              />
              <button
                className="btn-add-comment"
                onClick={saveMaterialStageData}
                disabled={!currentMaterialComment.trim()}
              >
                Agregar Comentario
              </button>
            </div>
          </div>

          {/* Envío de solicitud por correo */}
          <div className="modal-section">
            <button
              onClick={() => setShowEmailForm(!showEmailForm)}
              style={{
                width: '100%', padding: '10px 16px', background: '#111827',
                color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer',
                fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: '8px'
              }}
            >
              Enviar Solicitud por Correo {showEmailForm ? '▲' : '▼'}
            </button>

            {showEmailForm && (
              <div style={{ marginTop: '12px', background: '#f9fafb', borderRadius: '6px', padding: '16px' }}>
                {/* Contexto automático */}
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                  <span style={{ fontSize: '11px', background: '#e5e7eb', color: '#111827', padding: '2px 8px', borderRadius: '4px', fontWeight: '600' }}>{selectedMaterial.text}</span>
                  <span style={{ fontSize: '11px', background: '#e5e7eb', color: '#111827', padding: '2px 8px', borderRadius: '4px', fontWeight: '600' }}>{etapaLabel}</span>
                  {selectedMaterial.specialty && <span style={{ fontSize: '11px', background: '#e5e7eb', color: '#111827', padding: '2px 8px', borderRadius: '4px', fontWeight: '600' }}>{selectedMaterial.specialty}</span>}
                </div>

                {/* Destinatarios - miembros del equipo */}
                <p style={{ margin: '0 0 8px 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Destinatarios:</p>
                <div style={{ maxHeight: '140px', overflowY: 'auto', marginBottom: '10px' }}>
                  {(teamMembers || []).map((member, idx) => {
                    const mid = member.id || member._id;
                    return (
                      <label key={mid} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', cursor: 'pointer', borderRadius: '6px', background: emailDestinatarios.has(mid) ? '#e5e7eb' : 'transparent', marginBottom: '2px' }}>
                        <input type="checkbox" checked={emailDestinatarios.has(mid)} onChange={() => toggleDestinatario(mid)} style={{ cursor: 'pointer' }} />
                        <span style={{ width: '24px', height: '24px', borderRadius: '50%', background: getAvatarColor(idx), color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>
                          {(member.name || member.nombre || '?').charAt(0).toUpperCase()}
                        </span>
                        <span style={{ fontSize: '13px', color: '#1a1a1a' }}>{member.name || member.nombre}</span>
                        {(member.role || member.cargo) && <span style={{ fontSize: '11px', color: '#9ca3af' }}>({member.role || member.cargo})</span>}
                      </label>
                    );
                  })}
                </div>

                {/* Email libre */}
                <input
                  type="email"
                  placeholder="Email adicional externo (opcional)"
                  value={emailLibre}
                  onChange={(e) => setEmailLibre(e.target.value)}
                  className="file-input"
                  style={{ width: '100%', marginBottom: '10px', fontSize: '13px' }}
                />

                {/* Mensaje */}
                <textarea
                  placeholder="Escribe tu solicitud o mensaje..."
                  value={emailMensaje}
                  onChange={(e) => setEmailMensaje(e.target.value)}
                  rows="3"
                  className="comment-textarea"
                  style={{ marginBottom: '10px' }}
                />

                {/* Botón enviar + feedback */}
                <button
                  onClick={handleEnviarSolicitud}
                  disabled={enviandoCorreo || (emailDestinatarios.size === 0 && !emailLibre.trim()) || !emailMensaje.trim()}
                  style={{
                    width: '100%', padding: '10px', border: 'none', borderRadius: '6px',
                    background: enviandoCorreo ? '#94a3b8' : emailEnviado ? '#16a34a' : '#111827',
                    color: '#fff', fontWeight: '600', fontSize: '13px', cursor: enviandoCorreo ? 'wait' : 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                  }}
                >
                  {enviandoCorreo ? <><div className="spinner" style={{ width: '16px', height: '16px' }}></div> Enviando...</> : emailEnviado ? 'Correo enviado correctamente' : 'Enviar Solicitud'}
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={closeMaterialStageModal}>Cerrar</button>
          {completedProcessesMateriales[fileKey] && (
            <button
              className="btn-revert"
              onClick={revertMaterialProcess}
              disabled={isRevertingMaterialProcess}
              title="Descompletar este proceso y eliminar todos sus documentos"
            >
              {isRevertingMaterialProcess ? <div className="spinner"></div> : 'Descompletar Proceso'}
            </button>
          )}
          <button
            className="btn-save"
            onClick={markMaterialProcessComplete}
            disabled={isSavingMaterialProcess || (
              !materialProcessNoAplica &&
              (!materialStageFiles[fileKey] || materialStageFiles[fileKey].length === 0) &&
              (!materialStageComments[fileKey] || materialStageComments[fileKey].length === 0)
            )}
          >
            {isSavingMaterialProcess ? <div className="spinner"></div> : 'Guardar Proceso'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalProcesoMaterial;
